
import {
  RevIllustration,
  RevModal,
  RevSpinner,
} from '@backmarket/design-system'
import { mapGetters } from 'vuex'

import { MODAL_NAMES } from '@config/constants'
import IllustrationMoneyBagz from '@core/illustrations/IllustrationMoneyBagz.svg'
import IllustrationMoneyBagzSparkles from '@core/illustrations/IllustrationMoneyBagzSparkles.svg'
import { productGoodestFindsFetch } from '@http/endpoints'

import HighlightedPickersList from '../../HighlightedPickersList'

const ILLUSTRATIONS = {
  IllustrationMoneyBagz,
  IllustrationMoneyBagzSparkles,
}

export default {
  components: {
    HighlightedPickersList,
    RevIllustration,
    RevModal,
    RevSpinner,
  },
  data() {
    return {
      content: {},
      isLoading: true,
      hasError: false,
      selectedPickerId: 0,
    }
  },
  computed: {
    ...mapGetters({
      country: 'config/country',
    }),
    modalName() {
      return MODAL_NAMES.PRODUCT.HIGHLIGHTED_PICKERS
    },
    modalTitle() {
      return this.content.title
    },
    shouldDisplayContent() {
      return !this.isLoading && !this.hasError
    },
    pickers() {
      return this.content.buttons.map((picker, index) => ({
        ...picker,
        isSelected: index === this.selectedPickerId,
      }))
    },
    selectedPicker() {
      return {
        id: this.selectedPickerId,
      }
    },
    selectedPickerIllustration() {
      const img = this.content.buttons[this.selectedPickerId].image

      return ILLUSTRATIONS[img]
    },
    selectedPickersParagraphs() {
      return this.content.buttons[this.selectedPickerId].paragraphs
    },
    productId() {
      return this.$route.params.uuid
    },
  },
  methods: {
    async fetchGoodestFinds() {
      try {
        const { payload } = await this.$store.dispatch('http/request', {
          request: productGoodestFindsFetch,
          pathParams: { productId: this.productId },
        })

        this.content = { ...payload }
        this.isLoading = false
      } catch {
        this.isLoading = false
        this.hasError = true
      }
    },
    setSelectedPickerId(selectedPickerId) {
      this.selectedPickerId = selectedPickerId
    },
    handlePickersClick(index) {
      this.setSelectedPickerId(index)
    },
    onModalClose() {
      this.isLoading = true
      this.hasError = false
    },
  },
}
